import React, { useState } from 'react';
import sampleImage from '../../../assets/images/dashboard/body/tasksImg.svg';
import taskTick from '../../../assets/images/dashboard/body/taskTick.svg';
import twenty from '../../../assets/images/dashboard/body/20.svg';
import notification from '../../../assets/images/dashboard/header/bell.svg'
import arrow from '../../../assets/images/dashboard/header/doenArrow.svg'
import search from "../../../assets/images/dashboard/body/Search.svg"
import img from "../../../assets/images/img.svg"
import TaskdetailModal from '../../ui/TaskdetailModal';

const VolunteerTask = () => {
  const tasks = Array.from({ length: 10 }, (_, index) => ({
    id: index + 1,
    title: `Cleaning Task ${index + 1}`,
    date: '20/06/2023',
    description: 'Lorem ipsum dolor sit amet, consectetur adipiscing elit. Vivamus lacinia odio vitae...',
    priority: 'Moderate',
    status: 'Not Started',
  }));

  const [isModalOpen, setIsModalOpen] = useState(false);

  const [datePickerModal, setDatePickerModal] = useState(false);
  const toggleDatePickerModal = () => setDatePickerModal(!datePickerModal);


  return (
    <div className=" relative">

      <div className='hidden lg:flex py-4 lg:pr-10 bg_header border-b-2 border-[#362269]'>
        <div className='relative hidden lg:flex items-center pl-8'>
          <input type="search" placeholder='Search' className='min-w-[625px] h-8 border-0 rounded-lg' />
          <img src={search} alt="search" className='absolute right-[15px] top-[10px] ' />
        </div>

        <div className='hidden md:flex ml-auto items-center'>
          <span className='w-8 h-8  rounded-full'><img src={img} alt="img" /></span>

          <div className='flex items-center'>
            <p className='pl-3 font-bold'>Volunteer</p>
          </div>

          <img src={notification} alt="notification" className='pl-4 text-black' />
        </div>

      </div>

      <div className='xl:w-[85%] mx-auto mt-16 hidden lg:flex items-center justify-between'>

        <b className='font_family'>Available tasks</b>

        <div className='flex'>
          <button onClick={toggleDatePickerModal} className="w-[112px] h-[40px] border flex justify-center items-center border-gray-300 ml-2 bg-[#D6FACD] text-[10px] py-1 px-2 rounded-xl">
            Filter by date
            <img src={arrow} alt="arrow" className='w-[10px] h-auto p-[1px] ml-1' />
          </button>
        </div>
      </div>

      <div className="px-4 py-16 grid grid-cols-1 md:grid-cols-2 gap-6 relative">

      <div className='circle_design'></div>

        {tasks.map((task) => (
          <div key={task.id} className="border border-[#747474] mx-auto rounded-lg p-4 shadow-md max-w-[402px] bg-[#F6F2EF]">
            <div className="flex flex-col justify-between cursor-pointer w-full" onClick={() => setIsModalOpen(true)} >
              <div className="flex items-center justify-between w-full">
                <div className="flex items-center">
                  <div className="w-4 h-4 border-4 border-[#C6AFFF] rounded-full mr-2"></div>
                  <h3 className="">{task.title}</h3>
                </div>
                <span className="ml-auto text-[10px] text-[#747474]">Created on: {task.date}</span>
              </div>

              <div className="flex items-center justify-between">
                <p className="w-[80%] text-[14px] text-[#747474]">{task.description}</p>
                <div className="flex flex-col items-center mt-4 md:mt-0">
                  <img src={sampleImage} alt="Task" className="w-20 h-20" />
                </div>
              </div>

              <div className="flex justify-between">
                <div className="flex justify-start mt-4 text-[10px]">
                  <p className="mr-6">
                  Slot left: <span className="text-green-400">5</span>
                  </p>
                 
                </div>

              
              </div>
            </div>
          </div>
        ))}
      </div>

      {/* Popup Component */}
      <TaskdetailModal isOpen={isModalOpen} onClose={() => setIsModalOpen(false)} />
    </div>
  );
};

export default VolunteerTask;
